'use strict';

var Cookie = {};

Cookie.set = function (name, value, days) {
    var expires = '';
    if (days) {
        var date = new Date();
        date.setTime(date.getTime + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toGMTString();
    }
    document.cookie = name + '=' + value + expires + '; path=/';
};

Cookie.get = function (name, defaultValue) {
    if (document.cookie.length > 0) {
        var cookieStart = document.cookie.indexOf(name + '=');
        if (cookieStart != -1) {
            var valueStart = cookieStart + name.length + 1;
            var valueEnd = document.cookie.indexOf(';', valueStart);
            if (valueEnd == -1) {
                valueEnd = document.cookie.length;
            }
            return unescape(document.cookie.substring(valueStart, valueEnd));
        }
    }
    return defaultValue;
};

Cookie.delete = function (name) {
    Cookie.set(name, -1, -1);
};

module.exports = Cookie;
